import z from 'zod'

export const jsonRpcResponseSchema = z.object({
    id: z.string(),
    jsonrpc: z.enum(['1.0', '1.1', '1.2', '2.0']),
});

export const jsonRpcErrorResponseSchema = jsonRpcResponseSchema.extend({
    error: z.object({
        code: z.number(),
        message: z.string(),
    })
});

export type JsonRpcErrorResponse = z.output<typeof jsonRpcErrorResponseSchema>

export const positiveEmptyResponseSchema = z.object({
    code: z.number().min(0).max(0),
    msg: z.null(),
})

export type PositiveEmptyResponse = z.output<typeof positiveEmptyResponseSchema>

export const negativeErrorDataResponseSchema = z.object({
    code: z.number().positive(),
    msg: z.string(),
})

export type NegativeErrorDataResponse = z.output<typeof negativeErrorDataResponseSchema>

export const jsonRpcErrorWithDataResponseSchema = jsonRpcErrorResponseSchema.and(z.object({
    error: z.object({
        data: negativeErrorDataResponseSchema
    })
}))

export type JsonRpcErrorWithDataResponse = z.output<typeof jsonRpcErrorWithDataResponseSchema>

export const LKKJsonRpcErrorWithDataResponseSchema = jsonRpcErrorResponseSchema.and(z.object({
    error: z.object({
        data: z.object({
            details: z.string(),
            error: negativeErrorDataResponseSchema.and(z.object({
                error_parameters: z.array(z.object({
                    msg: z.string(),
                    parameter: z.string(),
                })).optional()
            })),
        })
    })
}))

export type LKKJsonRpcErrorWithDataResponse = z.output<typeof LKKJsonRpcErrorWithDataResponseSchema>

export const serverFormValidationErrorSchema = z.object({
    type: z.string(),
    loc: z.array(z.string()),
    input: z.any(),
    msg: z.string(),
})

export type ServerFormValidationError = z.output<typeof serverFormValidationErrorSchema>

export const serverFormValidationErrorListSchema = z.object({
    errors: z.array(serverFormValidationErrorSchema)
})

export type ServerFormValidationErrorList = z.output<typeof serverFormValidationErrorListSchema>

export const jsonRpcErrorWithValidationResponseSchema = jsonRpcErrorResponseSchema.and(z.object({
    error: z.object({
        data: serverFormValidationErrorListSchema
    })
}))

export type JsonRpcErrorWithValidationResponse = z.output<typeof jsonRpcErrorWithValidationResponseSchema>
